import { useContext, useState } from 'react'
import { TranslationsContext } from '@contexts/TranslationProvider'
import { useTranslation } from 'react-i18next'
import { getTranslations, WPPagesResponse } from '@api/wp-api/translations'

interface IHookState {
  setLanguage: Function
  selectedLanguage: string
}

const parseResponse = (responsePages: WPPagesResponse[]) => {
  // We need to parse this to get the keys
  let translationContent: { [key: string]: any } = {}
  responsePages.forEach((page) => {
    translationContent = { ...translationContent, ...page.acf }
  })
  return translationContent
}

/**
 * Hook that switches languages and pulls from API if required
 */
const useLanguageSwitcher = (): IHookState => {
  const context = useContext(TranslationsContext)
  const { i18n } = useTranslation()
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    context.selectedLanguage
  )

  const setLanguage = async (languageCode: string) => {
    // If we don't have the language in context then we need to fetch it from the api
    if (!context.translations[languageCode])
      await fetchLanguageContent(languageCode)
    // Set the new language in context and change language in i18n
    context.setSelectedLanguage(languageCode)
    await i18n.changeLanguage(languageCode)
    setSelectedLanguage(languageCode)
  }

  const fetchLanguageContent = async (languageCode: string) => {
    const response = await getTranslations(languageCode)
    const parsedResponse = parseResponse(response)
    await i18n.addResourceBundle(
      languageCode,
      'translation',
      parsedResponse,
      true,
      true
    )
    context.setTranslations({
      ...context.translations,
      [languageCode]: { translation: parsedResponse },
    })
  }

  return {
    setLanguage,
    selectedLanguage,
  }
}

export default useLanguageSwitcher
